import { TableCell, TableContainer } from '@material-ui/core';
import { Form } from '@unform/web';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  position: relative;
`;

export const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: 14rem;
`;

export const WrapperFullScreen = styled(Wrapper)`
  min-height: 100%;
  padding: 0 2.5rem;
  overflow-y: auto;

  .MuiTableCell-root {
    font-size: 2rem;
  }

  .MuiFormControl-root {
    margin-top: 0.6rem;
  }

  .mayWidh {
    width: 18rem;
  }

  .maySizeStatus {
    font-size: 1.5rem;
  }

  .MuiTableCell-sizeSmall {
    padding: 4px 20px 4px 10px;
  }
`;

export const Header = styled.header`
  padding: 0rem;
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const Container = styled(Form)`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;

  .MuiFilledInput-inputMarginDense {
    padding-top: 6px;
  }

  .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel) {
    margin-top: 3px;
  }

  .MuiFilledInput-root,
  .MuiFilledInput-root:hover {
    background-color: transparent !important;
  }
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem;
  position: absolute;
  width: 100%;

  .inputs-container {
    display: flex;
    flex-direction: unset;
    align-items: flex-start;
    gap: 1rem;
  }

  .actions-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-grow: 1;
  }

  .inputPerPage {
    max-width: 7rem;
    margin-left: 1rem;
    margin-right: 2rem;
  }

  input {
    text-align: center;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 2rem;
`;

export const WrapperContainer = styled(TableContainer)`
  height: ${({ maxHeight }) => maxHeight};
  max-height: 100%;

  position: relative;

  .MuiTableRow-root.Mui-selected,
  .MuiTableRow-root.Mui-selected:hover {
    background-color: rgba(0, 0, 0, 0.01) !important;
    box-shadow: 0px 3px 5px 0px rgb(0 0 0 / 30%);
  }

  tbody.MuiTableBody-root tr:nth-child(even) {
    background-color: rgba(0, 0, 0, 0.015);
  }

  @media (max-width: 600px) {
    .MuiTableCell-sizeSmall {
      padding: 4px 20px 4px 10px;
    }
  }
`;

export const CustomTableCell = styled(TableCell)`
  @media (max-width: 600px) {
    padding: 2px 4px;
  }
`;

export const CustomTableCellStatus = styled(TableCell)`
  font-size: 1.5rem;
`;

export const CustomTableCellFooter = styled(TableCell)`
  color: #333;
  font-size: 1.5rem;
  .MuiTableCell-root {
    font-size: 1.5rem;
  }
`;
